import { v4 as uuidv4 } from 'uuid';
import { ParameterNodeBuilder } from '../../builder/ParameterNodeBuilder';
import { CLONE_METHOD_NAME, cloneDeep } from '../../utils';
import { Type } from '../Type';
export class ParameterList extends Array {
    constructor(values = [], logicalType, tags) {
        super(...values);
        this.type = Type.List;
        this.logicalType = logicalType;
        this.tags = tags;
    }
    [CLONE_METHOD_NAME]() {
        return new ParameterList(this.map(cloneDeep), cloneDeep(this.logicalType), cloneDeep(this.tags));
    }
    static get [Symbol.species]() {
        return Array;
    }
    static new() {
        return new ParameterListBuilder();
    }
}
class ParameterListBuilder {
    constructor() {
        this.items = [];
    }
    addValue(key, value, build) {
        const builder = ParameterNodeBuilder.fromValue(uuidv4(), key, value);
        if (build)
            build(builder);
        const node = builder.build();
        this.items.push(node);
        return this;
    }
    addValues(values, build) {
        for (const [key, value] of values) {
            this.addValue(key, value, build);
        }
        return this;
    }
    build() {
        return new ParameterList(this.items);
    }
}
//# sourceMappingURL=data:application/json;base64,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